import {
  AppBar,
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Grid,
  Hidden,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  Switch,
  TextField,
  Toolbar,
  Typography,
  styled,
} from '@mui/material';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SquareIcon from '@mui/icons-material/Square';
import DonutSmallRoundedIcon from '@mui/icons-material/DonutSmallRounded';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SimCardIcon from '@mui/icons-material/SimCard';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { numberFormat, numberFormatText, numberFormatTextShorten } from '../../../../utils/helper';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import 'dayjs/locale/vi';
import { ButtonUI } from '../../../../component/CustomerMUI';
import { addCongnoAll, deleCongno, getCongnoDate, getCongnoID, updateCongnoID } from '../../../../services/apiDebt';
import range from 'lodash-es/range';

import classNames from 'classnames/bind';
import styles from './Debt.module.scss';
import PieChart from './PieChart';
import ExportExcelCN from './exportExcelCN';
import { updateImageShop } from '../../../../services/listSim';
const cx = classNames.bind(styles);

const Debt = ({ dataSim = [], bgrDF = '' }) => {
  // console.log(dataSim);
  const hostname = window.location.hostname;

  const [open, setOpen] = useState(false);

  const today = new Date();
  const date = today.getDate();
  const month = today.getMonth() + 1; // Lưu ý: Tháng bắt đầu từ 0 nên cần cộng thêm 1
  const year = today.getFullYear();
  const [resultDebt, setResultDebt] = useState([]);
  const [layoutCN, setLayoutCN] = useState(1);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdateID, setIsUpdateID] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultDetail, setResultDetail] = useState({});
  const [isStatus, setIsStatus] = useState(0);
  const [showPrice, setShowPrice] = useState(false);
  const [idSP, setIdSP] = useState(null);
  const [quantityOldHis, setQuantityOldHis] = useState(0);
  const [sellerHistory, setSellerHistory] = useState(() => {
    const data = localStorage.getItem('seller_history');
    return data ? JSON.parse(data) : [];
  });
  const rowDf = {
    date_cn: `${year}-${month}-${date}`,
    sim: '',
    seller: hostname,
    price: 0,
    goc: 0,
    hotro: 0,
    gdh: 0,
    dichvu: 0,
    hoahong: 0,
    tong: 0,
    note: '',
    domain: hostname,
    status: 1,
    daban: 1,
    quantity: 1,
  };
  const handleClose = () => {
    setOpen(false);
    setIsUpdate(false);
  };

  const removePrice = (index) => {
    setResultDebt((prevData) => prevData.filter((_, i) => i !== index));
  };

  useEffect(() => {
    let arrSim = [];
    Object.values(dataSim)?.map((item) => {
      let data = {
        date_cn: `${year}-${month}-${date}`,
        sim: item?.sim,
        seller: hostname,
        goc: parseInt(item?.goc),
        price: parseInt(item?.price),
        hotro: 0,
        gdh: 0,
        dichvu: 0,
        hoahong: 0,
        tong: parseInt(item?.price) - parseInt(item?.goc),
        note: '',
        domain: hostname,
        status: 1,
        daban: 1,
        quantity: parseInt(item?.quantity) - 1,
      };
      setIdSP(item?.id);
      setQuantityOldHis(item?.quantity_old || 0);
      // console.log(item?.quantity_old);
      arrSim.push(data);
    });

    setResultDebt(arrSim);
  }, [dataSim]);

  const handleDefault = () => {
    setResultDebt([...resultDebt, rowDf]);
    setIsUpdate(true);
  };

  const handleAddCN = async () => {
    setLoading(true);
    // console.log(resultDebt);
    const resultAPISIM = await addCongnoAll(resultDebt);
    UpdateKhoHang();
    if (resultAPISIM.message === 'Ok') {
      setIsUpdate(false);
      setIsUpdateID(false);
      setResultDebt([]);
      handleClose();
      setLoading(false);
    } else {
      setIsUpdate(false);
      setLoading(false);
    }
  };
  const handleUpdateCN = async () => {
    setLoading(true);
    await updateCongnoID(resultDebt[0]);
    setIsUpdate(false);
    setIsUpdateID(false);
    setResultDebt([]);
    setLayoutCN(2);
    handleGetCNDate(`${thisYear}-${thisMonth + 1}`);
    setLoading(false);
  };
  const handleDeleteCN = async () => {
    setLoading(true);
    const arrData = { ...resultDebt[0], status: 3 };
    await deleCongno(arrData);
    setIsUpdate(false);
    setIsUpdateID(false);
    setResultDebt([]);
    setLayoutCN(2);
    handleGetCNDate(`${thisYear}-${thisMonth + 1}`);
    setLoading(false);
  };
  const handleGetCNDate = async (date, isStt = isStatus) => {
    setLoading(true);
    const data = { domain: hostname, date: date, status: isStt };
    const resultAPISIM = await getCongnoDate(data);
    if (resultAPISIM?.total?.length > 0) {
      setResultDetail(resultAPISIM);
      setLoading(false);
    } else {
      setResultDetail([]);
      setLoading(false);
    }
  };
  const getIDCN = async (id) => {
    // setLoading(true);
    const resultAPISIM = await getCongnoID(id);
    if (resultAPISIM?.length > 0) {
      setResultDebt(resultAPISIM);
      setIsUpdateID(true);
      setLayoutCN(1);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const handleChange = (jsonValue, i) => {
    setIsUpdate(true);

    setResultDebt((prev) =>
      prev.map((obj, index) => {
        if (index !== i) return obj;

        // 👉 lấy daban cũ
        const oldDaban = parseInt(obj.daban) || 0;

        // 👉 lấy daban mới (ưu tiên jsonValue)
        const newDaban = jsonValue?.daban !== undefined ? parseInt(jsonValue.daban) || 0 : oldDaban;

        // 👉 tồn kho hiện tại
        const currentQuantity = parseInt(obj.quantity) || 0;

        // 👉 tính tồn kho mới (QUAN TRỌNG)
        const newQuantity = currentQuantity + oldDaban - newDaban;

        // 👉 các giá trị khác
        const price = jsonValue?.price ?? obj.price ?? 0;
        const goc = jsonValue?.goc ?? obj.goc ?? 0;
        const hotro = jsonValue?.hotro ?? obj.hotro ?? 0;
        const gdh = jsonValue?.gdh ?? obj.gdh ?? 0;
        const dichvu = jsonValue?.dichvu ?? obj.dichvu ?? 0;
        const hoahong = jsonValue?.hoahong ?? obj.hoahong ?? 0;

        const total = price * newDaban - goc * newDaban - hotro - gdh - dichvu - hoahong;

        return {
          ...obj,
          ...jsonValue,
          daban: newDaban,
          quantity: newQuantity, // 👈 cập nhật tồn kho thật
          tong: total,
        };
      }),
    );
  };

  const weekDays = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];

  const todayObj = dayjs();

  const [dayObj, setDayObj] = useState(dayjs());

  const thisYear = dayObj.year();
  const thisMonth = dayObj.month(); // (January as 0, December as 11)
  const daysInMonth = dayObj.daysInMonth();

  const dayObjOf1 = dayjs(`${thisYear}-${thisMonth + 1}-1`);
  const weekDayOf1 = dayObjOf1.day(); // (Sunday as 0, Saturday as 6)

  const dayObjOfLast = dayjs(`${thisYear}-${thisMonth + 1}-${daysInMonth}`);
  const weekDayOfLast = dayObjOfLast.day();

  const handlePrev = async () => {
    setLoading(true);
    setDayObj(dayObj.subtract(1, 'month'));
    const date = dayObj.subtract(1, 'month');
    const data = { domain: hostname, date: `${date.year()}-${date.month() + 1}`, status: isStatus };
    const resultAPISIM = await getCongnoDate(data);
    if (resultAPISIM?.total?.length > 0) {
      setResultDetail(resultAPISIM);
      setLoading(false);
    } else {
      setLoading(false);
      setResultDetail([]);
    }
  };

  const handleNext = async () => {
    setLoading(true);
    setDayObj(dayObj.add(1, 'month'));
    const date = dayObj.add(1, 'month');
    const data = { domain: hostname, date: `${date.year()}-${date.month() + 1}`, status: isStatus };
    const resultAPISIM = await getCongnoDate(data);
    if (resultAPISIM?.total?.length > 0) {
      setResultDetail(resultAPISIM);
      setLoading(false);
    } else {
      setLoading(false);
      setResultDetail([]);
    }
  };

  const saveSellerHistory = (value) => {
    if (!value || value.trim() === '') return;

    let list = [...sellerHistory];

    if (!list.includes(value)) {
      list.unshift(value); // thêm lên đầu
    }

    list = list.slice(0, 20); // tối đa 20 người

    setSellerHistory(list);
    localStorage.setItem('seller_history', JSON.stringify(list));
  };

  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      '&:after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  const handleDate = (data) => {
    const [year, month, day] = data.split('-');
    return `${day}/${month}/${year}`;
  };

  const UpdateKhoHang = async (e) => {
    if (resultDebt.length > 0 && idSP) {
      const arr = {
        id: idSP,
        quantity: resultDebt[0]['quantity'],
        quantity_sold: resultDebt[0]['daban'] + quantityOldHis,
      };
      // console.log(arr);
      const formData = new FormData();
      formData.append('data', JSON.stringify(arr));
      formData.append('dataDetail', JSON.stringify([]));
      const upload = await updateImageShop(formData);
      if (upload.message === 'OK') {
        window.location.reload();
      }
    }
  };

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar sx={{ position: 'relative', background: `var(--home-color)` }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, textTransform: 'uppercase', fontFamily: 'UTM-Avo' }}
              variant="h6"
              component="div"
            >
              {`CÔNG NỢ SIM ${hostname}`}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: '10px 6px' }}>
          <DialogContentText>
            <Grid container>
              <Grid container sx={{ mt: 1, pb: 1, borderBottom: '2px solid var(--home-color)' }}>
                <Stack direction={'row'} spacing={1}>
                  <ButtonUI
                    startIcon={<EditCalendarIcon />}
                    bgrColorBtn={layoutCN === 1 ? bgrDF + '26' : '#F3F4F6'}
                    colorText={layoutCN === 1 ? bgrDF : '#444444'}
                    borderBtn={layoutCN === 1 ? bgrDF + '4a' : '#4444440d'}
                    onClick={() => setLayoutCN(1)}
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {!isUpdateID ? `NHẬP CÔNG NỢ (${Object.values(dataSim).length})` : 'SỬA CÔNG NỢ'}
                  </ButtonUI>
                  <ButtonUI
                    startIcon={<CalendarMonthIcon />}
                    bgrColorBtn={layoutCN === 2 ? bgrDF + '26' : '#F3F4F6'}
                    colorText={layoutCN === 2 ? bgrDF : '#444444'}
                    borderBtn={layoutCN === 2 ? bgrDF + '4a' : '#4444440d'}
                    onClick={() => {
                      setLayoutCN(2);
                      handleGetCNDate(`${thisYear}-${thisMonth + 1}`);
                    }}
                  >
                    LỊCH
                  </ButtonUI>
                  <ButtonUI
                    startIcon={<DonutSmallRoundedIcon />}
                    bgrColorBtn={layoutCN === 3 ? bgrDF + '26' : '#F3F4F6'}
                    colorText={layoutCN === 3 ? bgrDF : '#444444'}
                    borderBtn={layoutCN === 3 ? bgrDF + '4a' : '#4444440d'}
                    onClick={() => {
                      setLayoutCN(3);
                      handleGetCNDate(`${thisYear}-${thisMonth + 1}`);
                    }}
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    BÁO CÁO
                  </ButtonUI>
                </Stack>
              </Grid>
              {layoutCN === 1 &&
                resultDebt?.length > 0 &&
                resultDebt.map((dis, i) => (
                  <Paper
                    key={i}
                    elevation={0}
                    sx={{
                      mb: 4,
                      p: 0,
                      borderRadius: '24px',
                      border: '1px solid #f1f5f9',
                      overflow: 'hidden',
                      background: '#fff',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
                        '& .summary-box': { bgcolor: '#0f172a' },
                      },
                    }}
                  >
                    <Grid container>
                      {/* CỘT 1: ĐỊNH DANH (Màu nền nhạt) */}
                      <Grid item xs={12} md={3} sx={{ p: 3, bgcolor: '#f8fafc', borderRight: '1px solid #f1f5f9' }}>
                        <Stack spacing={2.5}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box
                              sx={{
                                width: 32,
                                height: 32,
                                borderRadius: '10px',
                                bgcolor: '#2e7d32',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                fontWeight: 'bold',
                                fontFamily: 'UTM-Avo',
                              }}
                            >
                              {i + 1}
                            </Box>
                            <Typography
                              sx={{ fontFamily: 'UTM-Avo', fontWeight: 800, fontSize: '0.9rem', color: '#1e293b' }}
                            >
                              THÔNG TIN CHUNG
                            </Typography>
                          </Box>

                          <LocalizationProvider adapterLocale="vi" dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                              label="Ngày tháng"
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  variant: 'standard',
                                  sx: {
                                    '& .MuiInputBase-root': {
                                      fontFamily: 'UTM-Avo',
                                      fontWeight: 700,
                                      fontSize: '1rem',
                                    },
                                  },
                                },
                              }}
                              defaultValue={dayjs(dis.date_cn)}
                              onChange={(e) => handleChange({ date_cn: `${e.$y}-${e.$M + 1}-${e.$D}` }, i)}
                            />
                          </LocalizationProvider>

                          <TextField
                            fullWidth
                            label="TÊN SẢN PHẨM"
                            variant="standard"
                            placeholder="nhập tên sp..."
                            value={dis.sim}
                            InputLabelProps={{ sx: { fontFamily: 'UTM-Avo', fontWeight: 700, fontSize: '0.9rem' } }}
                            InputProps={{ sx: { fontFamily: 'UTM-Avo', fontWeight: 800, color: '#2563eb' } }}
                            onChange={(e) => handleChange({ sim: e.target.value || '' }, i)}
                          />

                          <Autocomplete
                            freeSolo
                            options={sellerHistory}
                            value={dis?.seller || ''}
                            onInputChange={(event, newInputValue) => {
                              handleChange({ seller: newInputValue || '' }, i);
                            }}
                            onBlur={(e) => {
                              saveSellerHistory(e.target.value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label="NGƯỜI BÁN"
                                variant="standard"
                                InputLabelProps={{
                                  sx: { fontFamily: 'UTM-Avo', fontWeight: 700, fontSize: '0.9rem' },
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  sx: { fontFamily: 'UTM-Avo' },
                                }}
                              />
                            )}
                          />
                        </Stack>
                      </Grid>

                      {/* CỘT 2: CHI PHÍ (Bento nhỏ) */}
                      <Grid item xs={12} md={6} sx={{ p: 3 }}>
                        <Typography
                          sx={{
                            fontFamily: 'UTM-Avo',
                            fontWeight: 800,
                            fontSize: '0.8rem',
                            color: '#94a3b8',
                            mb: 2,
                            textTransform: 'uppercase',
                            letterSpacing: 1,
                          }}
                        >
                          Chi tiết tài chính
                        </Typography>

                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            gap: 2,
                          }}
                        >
                          {[
                            { label: 'Giá Khách', key: 'price', color: '#059669' },
                            { label: 'Hỗ trợ', key: 'hotro', color: '#e11d48' },
                            { label: 'GDH (SHIP)', key: 'gdh', color: '#475569' },
                            // { label: 'Dịch vụ', key: 'dichvu', color: '#475569' },
                            // { label: 'Hoa hồng', key: 'hoahong', color: '#7c3aed' },
                          ].map((item) => (
                            <Box
                              key={item.key}
                              sx={{
                                p: 1.5,
                                borderRadius: '16px',
                                border: '1px solid #f1f5f9',
                                transition: 'border-color 0.2s',
                                '&:focus-within': { borderColor: item.color },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'UTM-Avo',
                                  fontSize: '0.9rem',
                                  fontWeight: 800,
                                  color: '#94a3b8',
                                  mb: 0.5,
                                }}
                              >
                                {item.label}
                              </Typography>
                              <TextField
                                fullWidth
                                variant="standard"
                                value={numberFormat(dis?.[item.key]?.toString())}
                                InputProps={{
                                  disableUnderline: true,
                                  sx: { fontFamily: 'UTM-Avo', fontWeight: 700, color: item.color, fontSize: '0.9rem' },
                                }}
                                onChange={(e) =>
                                  handleChange({ [item.key]: parseInt(e.target.value.replace(/\./g, '')) || 0 }, i)
                                }
                              />
                            </Box>
                          ))}
                          {/* giá nhập nằm trong grid chi phí */}
                          {/* {dis?.goc !== 0 && ( */}
                          <Box
                            sx={{
                              p: 1.5,
                              borderRadius: '16px',
                              border: '1px solid #f1f5f9',
                              transition: 'all 0.2s',
                              '&:focus-within': { borderColor: '#055a96', bgcolor: '#f0f9ff' },
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'UTM-Avo',
                                fontSize: '0.9rem',
                                fontWeight: 800,
                                color: '#94a3b8',
                                mb: 0.5,
                                // textTransform: 'uppercase',
                              }}
                            >
                              Giá Nhập
                            </Typography>

                            <TextField
                              fullWidth
                              variant="standard"
                              // Logic ẩn/hiện: Nếu showPrice là false thì hiện chuỗi dấu chấm
                              value={showPrice ? numberFormat(dis?.goc?.toString()) : '••••••••'}
                              InputProps={{
                                disableUnderline: true,
                                sx: {
                                  fontFamily: 'UTM-Avo',
                                  fontWeight: 700,
                                  color: '#055a96',
                                  fontSize: '0.9rem',
                                  // Tùy chỉnh để icon không làm lệch dòng chữ
                                  alignItems: 'center',
                                },
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      size="small"
                                      onClick={() => setShowPrice(!showPrice)}
                                      sx={{ color: '#94a3b8', p: 0.5 }}
                                    >
                                      {showPrice ? (
                                        <VisibilityOffIcon sx={{ fontSize: '1.1rem' }} />
                                      ) : (
                                        <VisibilityIcon sx={{ fontSize: '1.1rem' }} />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              // Khi đang ẩn thì khóa không cho sửa để tránh lỗi dữ liệu, hoặc bạn có thể bỏ disabled
                              disabled={!showPrice}
                              onChange={(e) =>
                                handleChange({ goc: parseInt(e.target.value.replace(/\./g, '')) || 0 }, i)
                              }
                              sx={{
                                '& .MuiInputBase-input.Mui-disabled': {
                                  WebkitTextFillColor: '#055a96', // Giữ màu chữ đậm kể cả khi disabled
                                },
                              }}
                            />
                          </Box>
                          {/* )} */}

                          <Box
                            sx={{
                              p: 1.5,
                              borderRadius: '16px',
                              border: `1px solid ${(dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0) ? '#fecaca' : '#f1f5f9'}`,
                              background:
                                (dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0) ? '#fff1f2' : '#fff',
                              transition: 'all 0.2s',
                              '&:focus-within': {
                                borderColor:
                                  (dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0) ? '#dc2626' : '#e11d48',
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'UTM-Avo',
                                fontSize: '0.9rem',
                                fontWeight: 800,
                                color:
                                  (dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0) ? '#dc2626' : '#94a3b8',
                                mb: 0.5,
                              }}
                            >
                              Đã Bán
                            </Typography>

                            <TextField
                              fullWidth
                              type="number"
                              variant="standard"
                              value={dis?.daban}
                              error={(dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0)}
                              helperText={
                                (dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0)
                                  ? `⚠️ Vượt tồn kho (tối đa ${(dis?.quantity || 0) + (dis?.daban || 0)})`
                                  : ``
                              }
                              InputProps={{
                                disableUnderline: true,
                                sx: {
                                  fontFamily: 'UTM-Avo',
                                  fontWeight: 700,
                                  color:
                                    (dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0)
                                      ? '#dc2626'
                                      : '#e11d48',
                                  fontSize: '1rem',
                                  borderBottom:
                                    (dis?.daban || 0) > (dis?.quantity || 0) + (dis?.daban || 0)
                                      ? '2px solid #dc2626'
                                      : '2px solid transparent',
                                },
                              }}
                              onChange={(e) => {
                                const value = parseInt(e.target.value.replace(/\./g, '')) || 0;

                                handleChange({ daban: value }, i);
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              p: 1.5,
                              borderRadius: '16px',
                              border: '1px solid #f1f5f9',
                              transition: 'border-color 0.2s',
                              '&:focus-within': { borderColor: '#e11d48' },
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'UTM-Avo',
                                fontSize: '0.9rem',
                                fontWeight: 800,
                                color: '#94a3b8',
                                mb: 0.5,
                              }}
                            >
                              Tồn Kho
                            </Typography>
                            <TextField
                              fullWidth
                              type="number"
                              variant="standard"
                              value={parseInt(dis?.quantity)}
                              InputProps={{
                                disableUnderline: true,
                                sx: { fontFamily: 'UTM-Avo', fontWeight: 700, color: '#e11d48', fontSize: '0.9rem' },
                              }}
                              disabled
                              // onChange={(e) =>
                              //   handleChange({ daban: parseInt(e.target.value.replace(/\./g, '')) || 1 }, i)
                              // }
                            />
                          </Box>

                          {/* Ghi chú nằm trong grid chi phí */}
                          <Box sx={{ p: 1.5, borderRadius: '16px', border: '1px solid #f1f5f9', gridColumn: 'span 3' }}>
                            <Typography
                              sx={{
                                fontFamily: 'UTM-Avo',
                                fontSize: '0.9rem',
                                fontWeight: 800,
                                color: '#94a3b8',
                                mb: 0.5,
                              }}
                            >
                              Ghi chú
                            </Typography>
                            <TextField
                              fullWidth
                              variant="standard"
                              value={dis?.note}
                              InputProps={{ disableUnderline: true, sx: { fontFamily: 'UTM-Avo', fontSize: '0.8rem' } }}
                              onChange={(e) => handleChange({ note: e.target.value || '' }, i)}
                            />
                          </Box>
                        </Box>

                        <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <FormControlLabel
                            control={
                              <Android12Switch
                                onChange={() => handleChange({ status: dis.status === 1 ? 2 : 1 }, i)}
                                checked={dis.status === 1}
                              />
                            }
                            label={
                              <Typography sx={{ fontFamily: 'UTM-Avo', fontSize: '0.9rem', fontWeight: 700 }}>
                                {dis.status === 1 ? 'Hoàn Thành' : 'Chưa Nhận'}
                              </Typography>
                            }
                          />

                          <Stack direction="row" spacing={1}>
                            {layoutCN === 1 && !isUpdateID && (
                              <Button
                                size="small"
                                variant="text"
                                color="error"
                                onClick={() => removePrice(i)}
                                sx={{ fontFamily: 'UTM-Avo', fontWeight: 700 }}
                              >
                                Xóa
                              </Button>
                            )}
                            {layoutCN === 1 && isUpdateID && (
                              <>
                                <Button
                                  size="small"
                                  variant="text"
                                  color="error"
                                  onClick={handleDeleteCN}
                                  sx={{ fontFamily: 'UTM-Avo', fontWeight: 700 }}
                                >
                                  Xóa
                                </Button>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="warning"
                                  onClick={handleUpdateCN}
                                  sx={{ fontFamily: 'UTM-Avo', fontWeight: 700, borderRadius: '10px' }}
                                >
                                  Cập nhật
                                </Button>
                              </>
                            )}
                          </Stack>
                        </Box>
                      </Grid>

                      {/* CỘT 3: TỔNG KẾT (Màu nền đậm) */}
                      <Grid
                        item
                        xs={12}
                        md={3}
                        className="summary-box"
                        sx={{
                          p: 3,
                          bgcolor: '#1e293b',
                          color: '#fff',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          textAlign: 'center',
                          transition: 'background-color 0.3s',
                        }}
                      >
                        <Typography
                          sx={{ fontFamily: 'UTM-Avo', fontSize: '0.8rem', opacity: 0.6, mb: 1, letterSpacing: 1 }}
                        >
                          TỔNG NHẬN
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'UTM-Avo',
                            fontSize: '1.8rem',
                            fontWeight: 800,
                            color: '#4ade80',
                            textShadow: '0 4px 12px rgba(74, 222, 128, 0.2)',
                          }}
                        >
                          {numberFormat(
                            (
                              dis.price * dis.daban -
                              dis.hotro -
                              dis.gdh -
                              dis.dichvu -
                              dis.hoahong -
                              dis.goc * dis.daban
                            ).toString(),
                          )}
                        </Typography>
                        <Typography sx={{ fontFamily: 'UTM-Avo', fontSize: '0.9rem', fontWeight: 700, opacity: 0.9 }}>
                          VNĐ
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                ))}

              {/* NÚT ĐIỀU KHIỂN CHÍNH */}
              {layoutCN === 1 && !isUpdateID && (
                <Stack direction="column" spacing={2} sx={{ mt: 4 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleDefault}
                    sx={{
                      fontFamily: 'UTM-Avo',
                      py: 2,
                      borderRadius: '20px',
                      bgcolor: '#fff',
                      color: '#1e293b',
                      fontWeight: 800,
                      border: '2px solid #1e293b',
                      '&:hover': { bgcolor: '#1e293b', color: '#fff' },
                    }}
                  >
                    + THÊM DÒNG MỚI
                  </Button>
                  {/* {isUpdate && ( */}
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleAddCN}
                    sx={{
                      fontFamily: 'UTM-Avo',
                      py: 2,
                      borderRadius: '20px',
                      bgcolor: '#2e7d32',
                      fontWeight: 800,
                      disableElevation: true,
                      '&:hover': { bgcolor: '#1b5e20', boxShadow: '0 8px 20px rgba(46,125,50,0.3)' },
                    }}
                    disabled={loading}
                  >
                    LƯU CÔNG NỢ
                  </Button>
                  {/* )} */}
                </Stack>
              )}

              {layoutCN === 2 && (
                <>
                  <Grid container spacing={1} justifyContent={'center'}>
                    <Grid item xs={12} md={8}>
                      <div className={cx('calendar')}>
                        <div className={cx('header')}>
                          <button
                            type="button"
                            className={cx('nav', 'nav--prev')}
                            onClick={() => {
                              handlePrev();
                            }}
                          >
                            &lt;
                          </button>
                          <div className={cx('datetime')}>{dayObj.locale('vi').format('MMM/YYYY')}</div>
                          <button
                            type="button"
                            className={cx('nav', 'nav--prev')}
                            onClick={() => {
                              handleNext();
                            }}
                          >
                            &gt;
                          </button>
                        </div>
                        <div className={cx('week-container')}>
                          {weekDays.map((d) => (
                            <div className={cx('week-cell', 'bgr-week')} key={d}>
                              {d}
                            </div>
                          ))}
                        </div>
                        <div className={cx('day-container')}>
                          {range(weekDayOf1).map((i) => (
                            <div className={cx('day-cell', 'day-cell--faded')} key={i}>
                              {dayObjOf1.subtract(weekDayOf1 - i, 'day').date()}
                            </div>
                          ))}

                          {range(daysInMonth).map((i) => (
                            <div
                              className={cx(
                                `day-cell`,
                                `day-cell--in-month${
                                  i + 1 === todayObj.date() &&
                                  thisMonth === todayObj.month() &&
                                  thisYear === todayObj.year()
                                    ? 'day-cell--today'
                                    : ''
                                }`,
                                `${
                                  i + 1 === todayObj.date() &&
                                  thisMonth === todayObj.month() &&
                                  thisYear === todayObj.year()
                                    ? 'active-day'
                                    : ''
                                }`,
                              )}
                              key={i}
                            >
                              <span className={cx('dis-price')}>
                                {i + 1} <br />{' '}
                                <b className={cx('note-price')}>
                                  {numberFormatTextShorten(
                                    resultDetail?.total?.find(
                                      (item) => item.date_cn === `${thisYear}-${thisMonth + 1}-${i + 1}`,
                                    )?.loinhuan,
                                  )}
                                </b>
                              </span>
                            </div>
                          ))}

                          {range(6 - weekDayOfLast).map((i) => (
                            <div className={cx('day-cell', 'day-cell--faded')} key={i}>
                              {dayObjOfLast.add(i + 1, 'day').date()}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} justifyContent={'center'} sx={{ mt: 1 }} className={cx('font-avo')}>
                    <Grid item xs={12} md={8}>
                      <Stack direction={'row'} spacing={3} justifyContent={'space-between'}>
                        <Stack direction={'column'} spacing={0.5} alignItems={'center'}>
                          <span>Doanh số</span>
                          <b className={cx('ds-color')}>
                            {numberFormat(resultDetail?.totalAll?.doanhthu?.toString())}₫
                          </b>
                        </Stack>
                        <Stack direction={'column'} spacing={0.5} alignItems={'center'}>
                          <span>Dịch vụ</span>
                          <b className={cx('ct-color')}>
                            {numberFormat(resultDetail?.totalAll?.dichvusim.toString())}₫
                          </b>
                        </Stack>
                        <Stack direction={'column'} spacing={0.5} alignItems={'center'}>
                          <span>Tổng</span>
                          <b className={cx('ds-color')}>
                            +{numberFormat(resultDetail?.totalAll?.loinhuan.toString())}₫
                          </b>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent={'center'} sx={{ mt: 1 }} className={cx('font-avo')}>
                    <Grid item xs={12} md={8} sx={{ pb: 1, borderBottom: '2px solid var(--home-color)' }}>
                      <span style={{ marginBottom: 5 }}>
                        <b> Lọc theo tiêu chí:</b>
                      </span>
                      <Stack direction={'row'} spacing={1} sx={{ mt: 0.5 }}>
                        <ButtonUI
                          startIcon={<SentimentSatisfiedAltIcon />}
                          bgrColorBtn={isStatus === 1 ? bgrDF + '26' : '#F3F4F6'}
                          colorText={isStatus === 1 ? bgrDF : '#444444'}
                          borderBtn={isStatus === 1 ? bgrDF + '4a' : '#4444440d'}
                          onClick={() => {
                            handleGetCNDate(`${thisYear}-${thisMonth + 1}`, isStatus === 1 ? 0 : 1);
                            setIsStatus(isStatus === 1 ? 0 : 1);
                          }}
                        >
                          HOÀN THÀNH{' '}
                          {resultDetail?.detail?.length > 0 && isStatus === 1
                            ? `(${resultDetail?.detail?.length})`
                            : ``}
                        </ButtonUI>
                        <ButtonUI
                          startIcon={<SentimentVeryDissatisfiedIcon />}
                          bgrColorBtn={isStatus === 2 ? bgrDF + '26' : '#F3F4F6'}
                          colorText={isStatus === 2 ? bgrDF : '#444444'}
                          borderBtn={isStatus === 2 ? bgrDF + '4a' : '#4444440d'}
                          onClick={() => {
                            handleGetCNDate(`${thisYear}-${thisMonth + 1}`, isStatus === 2 ? 0 : 2);
                            setIsStatus(isStatus === 2 ? 0 : 2);
                          }}
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          CHƯA HOÀN THÀNH{' '}
                          {resultDetail?.detail?.length > 0 && isStatus === 2
                            ? `(${resultDetail?.detail?.length})`
                            : ``}
                        </ButtonUI>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} justifyContent={'center'} sx={{ mt: 1 }} className={cx('font-avo')}>
                    <Grid item xs={12} md={8}>
                      {resultDetail?.total?.map((lich, i) => (
                        <Grid item xs={12} key={i} sx={{ mb: 1 }}>
                          <Stack
                            direction={'row'}
                            spacing={1}
                            justifyContent={'space-between'}
                            className={cx('cus-detail-name')}
                          >
                            <span>
                              {handleDate(lich.date_cn)}(
                              {dayjs(`${lich.date_cn}`).day() > 0
                                ? `Th${parseInt(dayjs(`${lich.date_cn}`).day()) + 1}`
                                : 'CN'}
                              )
                            </span>
                            <span>{numberFormat(lich.loinhuan.toString())}₫</span>
                          </Stack>
                          {resultDetail?.detail?.map(
                            (row, index) =>
                              row.date_cn === lich.date_cn && (
                                <Stack
                                  direction={'column'}
                                  spacing={1}
                                  justifyContent={'space-between'}
                                  className={cx('cus-detail-name-1')}
                                  key={index}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={1}
                                    justifyContent={'space-between'}
                                    onClick={() => {
                                      getIDCN(row.id);
                                    }}
                                  >
                                    <span className={cx('dis-center')}>
                                      <SimCardIcon sx={{ color: row.status === 1 ? '#1abc9c' : 'red' }} /> {row.sim}{' '}
                                      <small>{row.note ? `(${row.note})` : ''}</small>
                                    </span>
                                    <span>
                                      {numberFormat(row.tong.toString())}₫ {'>'}
                                    </span>
                                  </Stack>
                                  {(row.hotro > 0 ||
                                    row.gdh > 0 ||
                                    row.dichvu > 0 ||
                                    row.hoahong > 0 ||
                                    row.hoahong > 0 ||
                                    row.status === 2 ||
                                    row.seller !== '') && (
                                    <>
                                      <Hidden only={['md', 'lg', 'xl']}>
                                        <div className={cx('box-list-subcate')}>
                                          <div className={cx('list-subcate')}>
                                            <Stack direction={'row'} spacing={1} justifyContent={'flex-start'}>
                                              {row.status === 2 && (
                                                <ButtonUI
                                                  bgrColorBtn={row.status === 2 ? '#fddddd' : '#cefffa'}
                                                  colorText={row.status === 2 ? '#d40000' : '#008c7f'}
                                                  borderBtn={row.status === 2 ? '#d40000' : '#008c7f'}
                                                  borderRadius={6}
                                                  small
                                                >
                                                  {`Chưa hoàn thành`}
                                                </ButtonUI>
                                              )}
                                              {row.seller !== '' && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                  borderRadius={6}
                                                  small
                                                >
                                                  {`CTV: ${row.seller}`}
                                                </ButtonUI>
                                              )}
                                              {row.hotro > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                  borderRadius={6}
                                                  small
                                                >
                                                  {`HTrợ: ${numberFormatText(row.hotro)}`}
                                                </ButtonUI>
                                              )}

                                              {row.gdh > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                  borderRadius={6}
                                                  small
                                                >
                                                  {`GDH: ${numberFormatText(row.gdh)}`}
                                                </ButtonUI>
                                              )}
                                              {row.dichvu > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                  borderRadius={6}
                                                  small
                                                >
                                                  {`DVụ: ${numberFormatText(row.dichvu)}`}
                                                </ButtonUI>
                                              )}
                                              {row.hoahong > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                  borderRadius={6}
                                                  small
                                                >
                                                  {`HHồng: ${numberFormatText(row.hoahong)}`}
                                                </ButtonUI>
                                              )}
                                            </Stack>
                                          </div>
                                        </div>
                                      </Hidden>
                                      <Hidden only={['sm', 'xs']}>
                                        <div className={cx('box-list-subcate')}>
                                          <div className={cx('list-subcate')}>
                                            <Stack direction={'row'} spacing={1} justifyContent={'flex-start'}>
                                              {row.status === 2 && (
                                                <ButtonUI
                                                  bgrColorBtn={row.status === 2 ? '#fddddd' : '#cefffa'}
                                                  colorText={row.status === 2 ? '#d40000' : '#008c7f'}
                                                  borderBtn={row.status === 2 ? '#d40000' : '#008c7f'}
                                                >
                                                  {`Chưa hoàn thành`}
                                                </ButtonUI>
                                              )}
                                              {row.seller !== '' && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                >
                                                  {`CTV: ${row.seller}`}
                                                </ButtonUI>
                                              )}
                                              {row.hotro > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                >
                                                  {`HTrợ: ${numberFormatText(row.hotro)}`}
                                                </ButtonUI>
                                              )}

                                              {row.gdh > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                >
                                                  {`GDH: ${numberFormatText(row.gdh)}`}
                                                </ButtonUI>
                                              )}
                                              {row.dichvu > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                >
                                                  {`DVụ: ${numberFormatText(row.dichvu)}`}
                                                </ButtonUI>
                                              )}
                                              {row.hoahong > 0 && (
                                                <ButtonUI
                                                  bgrColorBtn={'#F3F4F6'}
                                                  colorText={'#444444'}
                                                  borderBtn={'#4444440d'}
                                                >
                                                  {`HHồng: ${numberFormatText(row.hoahong)}`}
                                                </ButtonUI>
                                              )}
                                            </Stack>
                                          </div>
                                        </div>
                                      </Hidden>
                                    </>
                                  )}
                                </Stack>
                              ),
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </>
              )}

              {layoutCN === 3 && (
                <>
                  <Grid container spacing={1} justifyContent={'center'}>
                    <Grid item xs={12} md={8}>
                      <div className={cx('calendar')}>
                        <div className={cx('header')}>
                          <button
                            type="button"
                            className={cx('nav', 'nav--prev')}
                            onClick={() => {
                              handlePrev();
                            }}
                          >
                            &lt;
                          </button>
                          <div className={cx('datetime')}>{dayObj.locale('vi').format('MMM/YYYY')}</div>
                          <button
                            type="button"
                            className={cx('nav', 'nav--prev')}
                            onClick={() => {
                              handleNext();
                            }}
                          >
                            &gt;
                          </button>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} justifyContent={'center'}>
                    <Grid item xs={12} md={6}>
                      <Stack direction={'row'} justifyContent={'space-around'} sx={{ mt: 1 }}>
                        {(resultDetail?.totalAll?.dichvusim || resultDetail?.totalAll?.loinhuan) && (
                          <PieChart
                            data={[resultDetail?.totalAll?.dichvusim || 0, resultDetail?.totalAll?.loinhuan || 0]}
                          />
                        )}
                        <Stack direction={'column'} justifyContent={'center'}>
                          <span style={{ whiteSpace: 'nowrap' }} className={cx('dis-center')}>
                            <SquareIcon sx={{ color: '#1abc9c' }} />
                            Lợi nhuận (
                            {(
                              (parseInt(resultDetail?.totalAll?.loinhuan) / resultDetail?.totalAll?.doanhthu || 0) * 100
                            ).toFixed(2)}{' '}
                            %)
                          </span>
                          <span style={{ whiteSpace: 'nowrap' }} className={cx('dis-center')}>
                            <SquareIcon sx={{ color: '#bf4040' }} />
                            Dịch vụ (
                            {(
                              (parseInt(resultDetail?.totalAll?.dichvusim) / resultDetail?.totalAll?.doanhthu || 0) *
                              100
                            ).toFixed(2)}
                            %)
                          </span>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} justifyContent={'center'} sx={{ mt: 1 }} className={cx('font-avo')}>
                    <Grid item xs={12} md={8}>
                      <Stack
                        direction={'row'}
                        spacing={2}
                        justifyContent={'space-evenly'}
                        className={cx('chart-report')}
                      >
                        <Stack direction={'column'} spacing={0.5} alignItems={'center'}>
                          <span>Doanh số</span>
                          <b className={cx('ds-color')}>
                            {numberFormat(resultDetail?.totalAll?.doanhthu?.toString())}₫
                          </b>
                        </Stack>
                        <Stack direction={'column'} spacing={0.5} alignItems={'center'}>
                          <span>Dịch vụ</span>
                          <b className={cx('ct-color')}>
                            {numberFormat(resultDetail?.totalAll?.dichvusim.toString())}₫
                          </b>
                        </Stack>
                        <Stack direction={'column'} spacing={0.5} alignItems={'center'}>
                          <span>Lợi nhuận</span>
                          <b className={cx('ds-color')}>
                            +{numberFormat(resultDetail?.totalAll?.loinhuan.toString())}₫
                          </b>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent={'center'} sx={{ mt: 1 }} className={cx('font-avo')}>
                    <Grid item xs={12} md={8}>
                      <span style={{ marginBottom: 5 }}>
                        <b> Lọc theo tiêu chí:</b>
                      </span>
                      <Stack direction={'row'} spacing={1} sx={{ mt: 0.5 }}>
                        <ButtonUI
                          startIcon={<SentimentSatisfiedAltIcon />}
                          bgrColorBtn={isStatus === 1 ? bgrDF + '26' : '#F3F4F6'}
                          colorText={isStatus === 1 ? bgrDF : '#444444'}
                          borderBtn={isStatus === 1 ? bgrDF + '4a' : '#4444440d'}
                          onClick={() => {
                            handleGetCNDate(`${thisYear}-${thisMonth + 1}`, isStatus === 1 ? 0 : 1);
                            setIsStatus(isStatus === 1 ? 0 : 1);
                          }}
                        >
                          HOÀN THÀNH{' '}
                          {resultDetail?.detail?.length > 0 && isStatus === 1
                            ? `(${resultDetail?.detail?.length})`
                            : ``}
                        </ButtonUI>
                        <ButtonUI
                          startIcon={<SentimentVeryDissatisfiedIcon />}
                          bgrColorBtn={isStatus === 2 ? bgrDF + '26' : '#F3F4F6'}
                          colorText={isStatus === 2 ? bgrDF : '#444444'}
                          borderBtn={isStatus === 2 ? bgrDF + '4a' : '#4444440d'}
                          onClick={() => {
                            handleGetCNDate(`${thisYear}-${thisMonth + 1}`, isStatus === 2 ? 0 : 2);
                            setIsStatus(isStatus === 2 ? 0 : 2);
                          }}
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          CHƯA HOÀN THÀNH{' '}
                          {resultDetail?.detail?.length > 0 && isStatus === 2
                            ? `(${resultDetail?.detail?.length})`
                            : ``}
                        </ButtonUI>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent={'center'} sx={{ mt: 1 }} className={cx('font-avo')}>
                    <Grid item xs={12} md={8}>
                      {/* <span style={{ marginBottom: 5 }}>
                        <b> Xuất File Excel:</b>
                      </span> */}
                      <Stack direction={'row'} spacing={1} sx={{ mt: 0.5 }}>
                        <ExportExcelCN dataSim={resultDetail} date={`${thisMonth + 1}-${thisYear}`} />
                      </Stack>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ĐÓNG</Button>
        </DialogActions>
      </Dialog>

      <Paper elevation={0}>
        <Card
          variant="outlined"
          sx={{ borderRadius: 2, background: '#f20055', color: '#fff', cursor: 'pointer' }}
          onClick={() => {
            setOpen(true);
          }}
        >
          <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
            {' '}
            <Stack direction="row" spacing={0} justifyContent="space-between" alignItems="center">
              <h3 style={{ whiteSpace: 'nowrap' }}>CÔNG NỢ</h3>
            </Stack>
            {/* <Stack direction="column" spacing={0}>
              <span style={{ whiteSpace: 'nowrap' }}>{resultDebt.length > 0 ? `` : 'Chọn sim or tạo mới'}</span>
            </Stack> */}
          </CardContent>
        </Card>
      </Paper>
    </>
  );
};
export default Debt;
